function csrfToken() {
    return document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute("content");
}

export async function apiFetch(path, options = {}) {
    const headers = {
        Accept: "application/json",
        "X-CSRF-Token": csrfToken(),
        ...options.headers,
    };

    const hasJsonBody =
        options.body !== undefined && !(options.body instanceof FormData);

    if (hasJsonBody && !headers["Content-Type"]) {
        headers["Content-Type"] = "application/json";
    }

    return fetch(path, {
        credentials: "same-origin",
        ...options,
        headers,
    });
}
